import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    p: '16px 24px',
  },
  adminName: {
    fontSize: 16,
    fontWeight: '600',
    color: 'common.grey850',
    mb: '16px',
  },
  item: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    py: '12px',
    borderBottom: '1px solid',
    borderColor: 'common.border',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    flexShrink: 0,
  },
  // The two source files differ in size, so both are pinned to match.
  icon: {
    width: 18,
    height: 18,
  },
  name: {
    fontSize: 14,
    fontWeight: '500',
    color: 'grey.800',
  },
  email: {
    fontSize: 13,
    color: 'common.gray',
    wordBreak: 'break-all',
  },
  userType: {
    fontSize: 12,
    color: 'common.gray',
  },
  empty: {
    fontSize: 14,
    color: 'common.gray',
    py: '24px',
    textAlign: 'center',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
